import {Component} from '@packages/systems/wfdl';
import type {PageRecordType} from '@packages/systems/core/records/PageRecord';
import type {CollectionsType} from '@packages/systems/core/records/CollectionStateType';

import {
  getElementBindingContextNode,
  getPageBindingContextNode,
} from './BindingContextGraph';
import type {ConsolidatedBindingContext} from './consolidateBindingContext';
import {WebflowEnvironments} from '@packages/systems/core-constants';

export type {ConsolidatedBindingContext} from './consolidateBindingContext';
export {forTestSuite_consolidateBindingContext} from './consolidateBindingContext';

export {getPageBindingContextNode} from './BindingContextGraph';
export {
  bindingContextBoundaryElementTypes,
  isBindingContextBoundaryElement,
} from './boundary-creators';
export type {BindingContextGraphNode} from './BindingContextGraph';

export function getElementBindingContext(
  elementId: string,
  currentComponent: Component.ComponentType,
  componentMap: Component.ComponentMap,
  page: PageRecordType | null,
  collections: CollectionsType
): ConsolidatedBindingContext | null {
  const bindingContextNode = getElementBindingContextNode(
    elementId,
    currentComponent,
    componentMap,
    page,
    collections,
    WebflowEnvironments.DESIGNER
  );

  return bindingContextNode ? bindingContextNode.getBindingContext() : null;
}

export function getPageBindingContext(
  page: PageRecordType,
  collections: CollectionsType
): ConsolidatedBindingContext | null {
  const bindingContextNode = getPageBindingContextNode(
    page,
    collections,
    WebflowEnvironments.DESIGNER
  );
  return bindingContextNode.getBindingContext();
}

export {default as getElementConnectionOptions} from './getElementConnectionOptions';

export {default as validateDynamicContext} from './validateDynamicContext';
